import { ChangeDetectionStrategy, Component, computed, effect, inject, input } from '@angular/core';
import { SharedMaterialUIModule } from '@shared/modules/shared-material-ui.module';
import { InterventionStore } from '../../../intervention.store';

// What a provider is told of a case it has accepted (the Referral step of the provider portal): who the member is and how to reach them, why the
// referral was made, the primary problem, the risk rating, the presenting problems and the treatment goals. Nothing else of the member or the
// assessment is shared; the server sends this only once the provider has accepted the case.
@Component({
  selector: 'provider-referral-summary',
  imports: [...SharedMaterialUIModule],
  templateUrl: './provider-referral-summary.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ProviderReferralSummaryComponent {
  protected readonly store = inject(InterventionStore);

  readonly interventionId = input.required<string>();

  // The stage of the case: the summary is read again when it changes, since accepting the referral is what opens it to the provider.
  readonly interventionStatus = input<string | null>(null);

  protected readonly summary = this.store.referralSummary;

  // Whether the provider has been told anything yet (before it accepts the case the server sends nothing).
  protected readonly hasContent = computed(() => {
    const summary = this.summary();
    return (
      !!summary.member ||
      !!summary.reason ||
      !!summary.primaryProblem ||
      !!summary.riskRating ||
      summary.presentingProblems.length > 0 ||
      summary.treatmentGoals.length > 0
    );
  });

  constructor() {
    effect(() => {
      void this.interventionStatus();
      this.store.loadReferralSummary(this.interventionId());
    });
  }
}
